import { render, staticRenderFns } from "./Privacy2.vue?vue&type=template&id=568eea79&scoped=true"
var script = {}
import style0 from "./Privacy2.vue?vue&type=style&index=0&id=568eea79&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568eea79",
  null
  
)

export default component.exports